import { createElement } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { ErroConhecidoPage } from '@/features/kedb/ErroConhecidoPage';
import { ErrosConhecidosPage } from '@/features/kedb/ErrosConhecidosPage';
import { CAMINHO_ERRO, CAMINHO_ERROS } from '@/features/kedb/navegacao';

/**
 * Rotas da Base de Erros Conhecidos.
 *
 * Duas rotas irmãs, e não uma raiz com filhas: a lista e a ficha não
 * compartilham casca.
 *
 * A KEDB tem endereço próprio na navegação principal por uma razão de processo,
 * e não de organização de menu: ela precisa ser consultável **antes** de o
 * atendimento começar. O ganho maior, porém, não está aqui — está na sugestão
 * automática dentro do chamado (`SugestoesDeErroConhecido`), que aparece sem
 * ninguém procurar.
 */
export function criarRotasDeErrosConhecidos<TRotaPai extends AnyRoute>(rotaPai: TRotaPai) {
  const lista = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_ERROS,
    /**
     * O termo de busca vive na URL, e não no estado da tela: assim o resultado
     * pode ser mandado por mensagem, e recarregar não perde a pesquisa.
     */
    validateSearch: (entrada: Record<string, unknown>): { q?: string } => {
      const q = entrada['q'];
      return typeof q === 'string' && q.trim() !== '' ? { q: q.trim() } : {};
    },
    component: ErrosConhecidosPage,
  });

  const detalhe = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_ERRO,
    // `createElement` em vez de JSX para este arquivo continuar sendo `.ts`.
    component: () => {
      const { erroId } = detalhe.useParams() as { erroId: string };
      return createElement(ErroConhecidoPage, { erroId });
    },
  });

  return { lista, detalhe };
}

export { CAMINHO_ERRO, CAMINHO_ERROS };
